import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "rgb(97,159,180)",
    },
    secondary: {
      main: "rgb(50,56,56)",
    },
    white: {
      main: "rgb(255, 255, 255)",
    },
    black: {
      main: "rgb(0, 0, 0)",
    },
    blackWithAlpha: {
      main: "rgb(0, 0, 0, 0.45)",
    },
  },
  typography: {
    fontFamily: "Raleway",
  },
});

export default theme;
